import React, { useEffect, useState } from "react";

import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CustomerForm from "./CustomerForm";
import { KeyboardArrowLeft } from "@mui/icons-material";
import { setupInitialDate } from "../utils/utils";

const SearchEditData = ({
  sheetData,
  setCurrentTab,
  selectedCustomer,
  setSelectedCustomer,
  showEditForm,
  setShowEditForm,
  getSheetData,
  parent,
  showUnsavedPopup,
  setShowUnsavedPopup,
  hasUnsavedChanges,
  setHasUnsavedChanges,
  appFields,
}) => {
  const [selectedPC, setSelectedPC] = useState(null);
  const [loading, setLoading] = useState(parent && parent === "search" ? true :  false)
  let options = sheetData?.map((dataItem) => {
    return `${dataItem["Prospect Card No."] ?? ""} - ${dataItem["Customer Name"] ?? ""} - ${dataItem["Sales Consultant"] ?? ""}`;
  });

  const handleChange = (e, newValue) => {    
    setSelectedPC(newValue);
  };

  const getCustomerData = () => {
    let selectedPCNumber = selectedPC?.split(" - ")?.[0];
    
    sheetData?.map((customerData) => {
      if (customerData["Prospect Card No."] === selectedPCNumber) {
        // let customerWithNewDate = setupInitialDate(customerData);
        setSelectedCustomer(customerData);
      }
    });
    setShowEditForm(true);
  };

  const handlePopupExit = () => {
  if(parent === "search") {
setCurrentTab("searchEntry")
  }
  else{
    setCurrentTab(null);
   
  }
  setSelectedCustomer({});
  setShowEditForm(false);
  setShowUnsavedPopup(false);
  setHasUnsavedChanges(false);
  setTimeout(() => {
    localStorage.removeItem("addFormData");
    localStorage.removeItem("editFormData");
  }, 1000);
  };

  useEffect(()=>{
    parent && parent ==="search" && loading && setTimeout(() => {
      setLoading(false);
    }, 1000);
  },[])

  

  return (
    <Box>
      <Button
        variant="outlined"
        className="navigaton_button"
        onClick={() => {
          if (hasUnsavedChanges) {
            setShowUnsavedPopup(true);
          } else {
            setCurrentTab(null);
            setSelectedCustomer({});
            setShowEditForm(false);
            // getSheetData();
          }
        }}
      >
        <KeyboardArrowLeft /> Back to Home
      </Button>
      {parent && parent === "search" && (
        <Button
          variant="outlined"
          className="navigaton_button"
          style={{ marginLeft: "20px" }}
          onClick={() => {
           if(hasUnsavedChanges) {
            setShowUnsavedPopup(true);
           }
           else{
            setCurrentTab("searchEntry");
            setSelectedCustomer({});
            setShowEditForm(false);
            // getSheetData();
           }
          }}
        >
          <KeyboardArrowLeft /> Back to Search
        </Button>
      )}
      <Container maxWidth="sm" className="CustomerFormContainer">
        <Typography fullWidth variant="h6" className="section_header">
          EDIT EXISTING
        </Typography>
        <Autocomplete
          fullWidth
          options={options}
          getOptionLabel={(option) => option} // Since the options are strings, just return the option itself
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select an option"
              variant="outlined"
            />
          )}
          onChange={handleChange}
        />
        <Stack
          fullWidth
          direction={"row"}
          marginTop={2}
          marginBottom={4}
          justifyContent={"flex-end"}
        >
          <Button
            variant="contained"
            onClick={getCustomerData}
            disabled={!selectedPC}
          >
            Get Data
          </Button>
        </Stack>
        {/* <Divider/> */}
        {loading ? <Stack fullWidth direction={"row"} justifyContent={"center"}><CircularProgress/></Stack> :  showEditForm && (
          <CustomerForm
            setCurrentTab={setCurrentTab}
            sheetData={sheetData}
            editForm={true}
            selectedCustomer={selectedCustomer}
            showEditForm={showEditForm}
            showUnsavedPopup={showUnsavedPopup}
            setShowUnsavedPopup={setShowUnsavedPopup}
            hasUnsavedChanges={hasUnsavedChanges}
            setHasUnsavedChanges={setHasUnsavedChanges}
            // getSheetData={getSheetData}
            handlePopupExit={handlePopupExit}
            appFields={appFields}
          />
        )}
      </Container>
    </Box>
  );
};

export default SearchEditData;
